import { gql } from '@apollo/client';
import { useUserContext } from '@ion/user';
import useQuery from 'api/hooks/useQuery';
import permissions from 'api/Apollo/permissions';

export const ORG_PRIMARY_CLUSTER_QUERY = 'OrgPrimaryCluster';

export const query = gql`
  query OrgPrimaryCluster($orgId: String!) {
    org: orgs_by_pk(id: $orgId) {
      id
      primaryClusterId
    }
  }
`;

export default function useQueryOrgPrimaryCluster(options = {}) {
  const { currentOrg } = useUserContext();

  const { data, loading, error } = useQuery(query, {
    variables: { orgId: currentOrg.id },
    context: { permission: permissions.readCluster },
    ...options,
  });

  return {
    primaryClusterId: data?.org.primaryClusterId ?? null,
    loading,
    error,
  };
}
